import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "hooks";
import { setToken } from "state/reducers/AuthSlice";
import { Spinner } from "components/atoms/Icon";
import { OnboardingFormTitleSection } from "components/organisms/OnboardingFormTitleSection";
import { OnboardingFormSection } from "components/organisms/OnboardingFormSection";
import { useNeedsGuaranteeOnboardingFormQuery } from "services/onboardingFormsAPI";
import "./index.scss";

interface IProps {
  theme: "light" | "dark";
}

export const OnboardingHome = ({ theme }: IProps) => {
  const dispatch = useAppDispatch();

  const location = useLocation();

  const { token } = useAppSelector((state) => state.auth);

  const { isLoading, isError, data } = useNeedsGuaranteeOnboardingFormQuery();

  useEffect(() => {
    if (location.search !== "") {
      dispatch(setToken(location.search.split("=")[1]));
    }
  }, [location.search]);

  if (token !== "" && !isLoading && !isError) {
    if (
      data.hasOwnProperty("NeedsGuaranteeForm") &&
      data?.NeedsGuaranteeForm === true
    ) {
      return (
        <div className="onboarding-home-wrapper">
          <OnboardingFormTitleSection />
          <OnboardingFormSection />
        </div>
      );
    } else {
      window.location.href = `${process.env.REACT_APP_RETURN_URL}`;
      return null;
    }
  } else {
    return <Spinner theme={theme} />;
  }
};
